import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import doctorAPI from '../../sources/api/doctorAPI';

// constants
import { DOCTOR_AVAILABILITIES_FETCH } from '../../constants/doctorTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { doctorAvailabilityListSchema } from '../../schemas/Normalizr';

export function* doctorAvailabilitiesFetch(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(DOCTOR_AVAILABILITIES_FETCH, call(doctorAPI.availabilitiesFetch, params), doctorAvailabilityListSchema);
  } catch (e) {
    yield put(error(DOCTOR_AVAILABILITIES_FETCH, e));
  } finally {
    yield put(doneIndicator(DOCTOR_AVAILABILITIES_FETCH));
  }
}

export function* watchDoctorAvailabilitiesFetch() {
  yield takeEvery(DOCTOR_AVAILABILITIES_FETCH, doctorAvailabilitiesFetch);
}

export default function* root() {
  yield all([
    fork(watchDoctorAvailabilitiesFetch)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/doctor/doctorAvailabilitiesFetch.js